import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=188361a7"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductCardLoading: require('/opt/build/repo/components/product/CardLoading.vue').default,ProductCardVertical: require('/opt/build/repo/components/product/CardVertical.vue').default})
